import { render, staticRenderFns } from "./edit-project.vue?vue&type=template&id=4b6a1a1e&"
import script from "./edit-project.vue?vue&type=script&lang=js&"
export * from "./edit-project.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports